import React, { useMemo } from "react";
import "./index.less";
import { Button } from "antd";
import { useHistory } from "react-router";
import { useGlobalStore } from "@/store/hooks";
import ShopType from "@/enum/ShopType";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";

interface RecommendFeaturesProps {}

const RecommendFeatures: React.FC<RecommendFeaturesProps> = function (props) {
    const history = useHistory();
    const globalStore = useGlobalStore();

    const dataSource = useMemo(() => {
        const firstManualShop = globalStore.allowedShops.find(({ type }) => {
            return type === ShopType.MANUAL;
        });

        return [
            {
                title: "物流预警异常",
                name: "物流预警异常",
                img: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01E1X42k2DwkNvyPgaR_!!54458674.png",
                target: "/setting/orderLogisticsWarning",
            },
            {
                name: "自由打印",
                title: (
                    <div>
                        自由打印
                        <span className="text-gray" style={{ fontSize: "10px" }}>
                            (手工订单)
                        </span>
                    </div>
                ),
                img: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01bjJUb52DwkNrYvbFL_!!54458674.png",
                target: firstManualShop
                    ? `/order/list?shopId=${firstManualShop.id}&tab=PENDING_SHIPMENT`
                    : "/setting/shop/add",
            },
            {
                title: "爆款打单",
                name: "爆款打单",
                img: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01IcL7Dh2DwkTQUYmjG_!!54458674.png",
                target: "https://qw15p3s8hv.feishu.cn/wiki/wikcnhXwRiWgtCkUUmYLntgMYee",
            },
            {
                title: "备货单/订单导出",
                name: "订单导出",
                img: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01LvOCdk2DwkNzx3FEG_!!54458674.png",
                target: "/features/orderExport",
            },
        ];
    }, []);

    function handleItemClick(item) {
        const { name, target } = item;

        collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
            content: name,
        });

        if ((target as string).startsWith("http")) {
            window.open(target, "_blank");
        } else {
            history.push(target);
        }
    }

    return (
        <div className="flex ec-recommend-features">
            {dataSource.map((item, index) => {
                const { img, title } = item;

                return (
                    <div key={index} className="point feature-item">
                        <img src={img} alt="" />
                        <div className="title">{title}</div>
                        <Button size="small" ghost type="primary" onClick={() => handleItemClick(item)}>
                            立即使用
                        </Button>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(RecommendFeatures);
